const StatsSection = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
          <div className="group hover:transform hover:scale-110 transition-all">
            <div className="text-5xl font-bold mb-2">5000+</div>
            <div className="text-blue-100 text-lg">Prodotti Disponibili</div>
          </div>
          <div className="group hover:transform hover:scale-110 transition-all">
            <div className="text-5xl font-bold mb-2">500+</div>
            <div className="text-blue-100 text-lg">Clienti Soddisfatti</div>
          </div>
          <div className="group hover:transform hover:scale-110 transition-all">
            <div className="text-5xl font-bold mb-2">24-48h</div>
            <div className="text-blue-100 text-lg">Consegna Media</div>
          </div>
          <div className="group hover:transform hover:scale-110 transition-all">
            <div className="text-5xl font-bold mb-2">5+</div>
            <div className="text-blue-100 text-lg">Anni di Esperienza</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
